import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fileId: null,
  fileName: "",
};

const fileMetaSlice = createSlice({
  name: "fileMeta",
  initialState,
  reducers: {
    setFileMeta: (state, action) => {
      state.fileId = action.payload.fileId;
      state.fileName = action.payload.fileName;
    },
    clearFileMeta: (state) => {
      state.fileId = null;
      state.fileName = "";
    },
  },
});

export const { setFileMeta, clearFileMeta } = fileMetaSlice.actions;
export default fileMetaSlice.reducer;
